import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { setUserDetails } from "../../features/user/UserSlice";
import { useDispatch } from "react-redux";
import getDemoUser from "../../utils/demo";
import { Button } from "@mui/material";
import FullPageLoader from "../../components/Loading/FullPageLoader";

const TryoutScreen = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleDemo = async () => {
    try {
      setLoading(true);

      const response = await getDemoUser();

      dispatch(
        setUserDetails({
          id: response?.user?.id,
          company_id: response?.user?.company_id,
          name: response?.user?.name,
          email: response?.user?.email_id,
          phone_number: response?.user?.phone_number,
          image: response?.user?.image,
          role: response?.user?.user_type,
          company_domain: response?.user?.company_details?.domain,
          is_demo_account: true,
        })
      );

      navigate("/demo");
    } catch (err) {
      console.log(err);
      setError("Something Went Wrong");
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };

  useEffect(() => {
    handleDemo();
  }, []);

  return (
    <>
      {error && <div className="text-danger">{error}</div>}
      {loading && <FullPageLoader text="Logging You with Demo Account" />}
      <div className="d-flex justify-content-center align-items-center">
        <div className="text-center">
          <h1 className="display-3">
            Experience the power of DialGrid AI Agent.
          </h1>
          <p className="lead">
            Try our intelligent assistant now with a demo account and see how it
            can enhance your communication
          </p>
          <Button onClick={handleDemo}>Try Now</Button>
        </div>
      </div>
    </>
  );
};

export default TryoutScreen;
